var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.32 15.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8080ae;\n      }\n\n      .cls-2 {\n        fill: #efccab;\n      }\n\n      .cls-3 {\n        fill: #a084aa;\n      }\n\n      .cls-4 {\n        fill: #d6b5d6;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        fill: #4bc5de;\n      }\n\n      .cls-7 {\n        fill: #118986;\n      }\n\n      .cls-8 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-9 {\n        fill: #f0e4f0;\n      }\n\n      .cls-10 {\n        fill: #cb99be;\n      }\n\n      .cls-11 {\n        fill: #e9c1db;\n      }\n\n      .cls-12 {\n        fill: #dd948e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M6.83.9s-.22.49-.25.5c.08.46.33.81.5,1.25,1.74-.31,2.6,3.77,5.76,3.76-1.01-.8.9-.23.75-2.13C13.33.97,9.43.13,6.83.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M.07,5.9c.12.02.49.47.5.5.89-.97,1.78-1.86,2.75-2.75.66-.6.72-.71,1.5-1.25.89-.62.64-.56,1.75-1,.03-.01.22-.49.25-.5C5.4-1.81.6,2.11.07,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.33,15.42c-.5-.57-.78-.22-1.25-1-.04-.06.03-.18,0-.25-1.67-.48-3.91-2.49-4.01-4.26-1.16-.81-1.03-2.36-1.5-3.51-.01-.03-.38-.48-.5-.5-.6,4.19,2.98,9.17,7.26,9.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.08,2.65c1.3,3.39,2.37,4.76,6.01,3.76h-.25c-3.16.02-4.01-4.07-5.76-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.32,3.65c-.49,1.18,0,2.32-.25,3.51.72-.7,1.78-.32,2.75-.25-.3-.48-1.22-3.9-1-4.51-.78.54-.85.65-1.5,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M.57,6.41c.47,1.15.34,2.69,1.5,3.51-.08-1.41.74-1.9.75-2,.14-1.01.24-.71.25-.75.24-1.19-.24-2.33.25-3.51-.98.89-1.86,1.78-2.75,2.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.82,2.4c-.22.61.7,4.02,1,4.51.62.98,5.58,1.86,6.89,1.5,1.12-.31,1.14-.87,1.88-1.5-.04-.82.98-1.37-.5-1-.25.06-.29.3-1,.5-3.64,1.01-4.71-.36-6.01-3.76-.17-.44-.42-.79-.5-1.25-1.11.44-.86.39-1.75,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M14.09,5.9c1.48-.37.46.18.5,1,.2,4.41-3.81,9.26-8.51,7.51.47.78.75.43,1.25,1,10.62.85,7.92-13.82,7.01-12.14l-.25,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M3.07,7.16s-.11-.25-.25.75c1.52,1.95,2.22,4.14,3.26,6.26.03.07-.04.19,0,.25,4.7,1.75,8.72-3.1,8.51-7.51-.74.63-.76,1.2-1.88,1.5-1.31.36-6.27-.53-6.89-1.5-.97-.07-2.03-.45-2.75.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2.07,9.91c.1,1.77,2.34,3.77,4.01,4.26-1.04-2.12-1.73-4.31-3.26-6.26-.01.11-.83.59-.75,2Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.23bb30480a959a570f0889c0c9377b61.svg";
export { ForwardRef as ReactComponent };